import Image from "react-bootstrap/Image";
import config from "../../config";
import React from "react";

const DiscoverProductVariation = ({product}) => {
    return (
        <a className="discover-carousel__product" href={product.url}>
            <div className="discover-carousel__product-img-container">
                <Image
                    alt={product.name}
                    title={product.name}
                    className="discover-carousel__product-img"
                    src={`${config.MEDIA_URL}/img/discover-carousel/${product.img}`}
                    width="400"
                    height="400"
                />
            </div>
            <div className="discover-carousel__product-info">
                <div className="discover-carousel__product-vendor">
                    {product.vendor}
                </div>
                <div className="discover-carousel__product-title">
                    {product.title}
                </div>
            </div>
        </a>
    )
}

export default DiscoverProductVariation;